import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_144_add_payment: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Payments",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "pur_payment",
        TableName: "purchase_payments",
        Plugins: [{ type: "api", module: "all" }],
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        fieldVisibilityRules: [
          {
            when: { field: "drp_billmode", label: "Cheque" },
            showFields: ["txt_cheque_no", "txt_cheque_date"],
            fieldLabels: {
              txt_cheque_no: "Cheque No.",
              txt_cheque_date: "Cheque date",
            },
          },
          {
            when: { field: "drp_billmode", label: "Card" },
            showFields: ["txt_cheque_no", "txt_cheque_date"],
            fieldLabels: {
              txt_cheque_no: "Card Ref No.",
              txt_cheque_date: "Card date",
            },
          },
        ],
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Payment details",
            BindValue: "con_payment_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_supplier",
                label: "Vendor",
                placeholder: "Select vendor",
                required: true,
                lookupName: "supplier_with_due_from_transaction",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "supplier_id",
                BindValue: "drp_supplier",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Vendor is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchase_pay_no",
                label: "Purchase payment No.",
                placeholder: "Will be auto generated...",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "purchase_payment_no",
                BindValue: "txt_purchase_pay_no",
                AutoPopulate: true,
                AutoPopulate_format: "PUR_PAY_[******]",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_date",
                label: "Payment date",
                placeholder: "",
                required: true,
                Json_Attribute: "purchase_date",
                BindValue: "txt_Purchase_date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Payment date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_billmode",
                label: "Payment mode",
                placeholder: "Select payment mode",
                clearable: true,
                required: true,
                lookupName: "billmodes_from_ledger",
                options: [],
                Json_Attribute: "bill_mode",
                BindValue: "drp_billmode",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Payment mode is required",
                  },
                ],
              },
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_bank",
                label: "DEBIT ACCOUNT",
                placeholder: "Select bank",
                clearable: true,
                required: false,
                lookupName: "get_all_ledgers",
                accountMasterKey: "payment_voucher_debit",
                options: [],
                Json_Attribute: "details",
                BindValue: "drp_bank",
                validation: [
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Cheque",
                    message: "Debit account is required when payment mode is Cheque",
                  },
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Card",
                    message: "Debit account is required when payment mode is Card",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_Payable_amount",
                label: "Ledger amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                disabled: true,
                Json_Attribute: "",
                BindValue: "txt_Payable_amount",
                BindParent: {
                  drp_supplier: "amount",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_total_amount",
                label: "Total amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                disabled: false,
                defaultValue: "0",
                Json_Attribute: "",
                BindValue: "txt_total_amount",
                ExpressionV2: "[(purchase_details).txt_net_amount]",
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_reference_date",
                label: "Reference date",
                placeholder: "",
                required: true,
                Json_Attribute: "reference_date",
                BindValue: "txt_reference_date",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Reference date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_Ref_no",
                label: "Ref No.",
                placeholder: "Ref No.",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "ref_no",
                BindValue: "txt_Ref_no",
              },
              {
                componentType: ComponentType.TEXT_AREA,
                name: "txt_remarks",
                label: "Narration",
                placeholder: "",
                required: true,
                rows: 4,
                Json_Attribute: "remarks",
                BindValue: "txt_remarks",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Narration is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_balance_amount",
                label: "Balance calculator",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                disabled: true,
                defaultValue: "0",
                Json_Attribute: "",
                BindValue: "txt_balance_amount",
                ExpressionV2: "[txt_Payable_amount] - [(purchase_details).txt_net_amount]",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_unregistered_amount",
                label: "Unregistered amount",
                placeholder: "Amount not allocated to purchases",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "unregistered_amount",
                BindValue: "txt_unregistered_amount",
                defaultValue: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_cheque_no",
                label: "Cheque No. / Card Ref No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "cheque_no",
                validation: [
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Cheque",
                    message: "Cheque no is required",
                  },
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Card",
                    message: "Card ref no is required",
                  },
                ],
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_cheque_date",
                label: "Cheque date",
                placeholder: "",
                Json_Attribute: "cheque_date",
                BindValue: "txt_cheque_date",
                validation: [
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Cheque",
                    message: "Cheque date is required",
                  },
                  {
                    rule: ValidationRule.CONDITIONAL_REQUIRED,
                    whenField: "drp_billmode",
                    whenLabel: "Card",
                    message: "Card date is required",
                  },
                ],
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "purchase_details",
            label: "Purchase details",
            tableName: "purchase_payment_split",
            lookupName: "vendor_purchase_details",
            parentField: "drp_supplier",
            DisableAddNewRow: true,
            BindValue: "purchase_payment_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchase_no",
                label: "Reference No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "purchase_no",
                disabled: true,
                BindValue: "txt_purchase_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_total_amount",
                label: "Total amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "total_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_total_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_paid_amount",
                label: "Amount paid",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount_paid",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_paid_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_discount_amount",
                label: "Discount amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "discounted_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_discount_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_amount",
                label: "Due amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_amount",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[amount] + [discount] <= [due_amount]",
                    message: "Amount and discount combined cannot exceed due amount",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_discount",
                label: "Discount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "discount",
                defaultValue: "0",
                BindValue: "txt_discount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_narration",
                label: "Narration",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "narration",
                BindValue: "txt_narration",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_5",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_9",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_8",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount] ",
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_discount",
                Json_Attribute: "net_discount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_discount] ",
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_10",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];

